import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';

import UIStore from '../stores/UIStore';
import UserStore from '../stores/UserStore';
import Feedback from 'components/Feedback';

import { useQueryParameters } from '@partsbadger/utils';
import { useHistory } from 'react-router';

import AuthLayout from 'components/AuthLayout';
import { Card, Col, Row, Tag, Typography } from 'antd';
import UTMQueryPreservingLink from '../common/UTMQueryPreservingLink';
import RedirectPreservingUTMQuery from '../common/RedirectPreservingUTMQuery';

const PortalRegister = () => {
    const query = useQueryParameters();
    const feedback_sales_order_name = query.get('feedback_sales_order');

    const next_url = query.get('next') || '/my-account/';
    const history = useHistory();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const redirectToPortal = () => {
        history.push('/my-account/');
    };

    useEffect(() => {
        if (feedback_sales_order_name) {
            setIsModalVisible(true);
        } else {
            UIStore.setSelectedKey(['my-account']);
            UIStore.setDocumentTitle('Login');
        }
    }, []);

    useEffect(() => {
        const button = document.getElementById('header-login-button');

        if (button) {
            button.style.display = 'none';
        }

        return () => {
            const button = document.getElementById('header-login-button');
            if (button) {
                button.style.display = '';
            }
        };
    }, []);

    useEffect(() => {
        const email = query.get('email');
        const first_name = query.get('first_name');
        const last_name = query.get('last_name');
        const company = query.get('company');

        if (email || first_name || last_name || company) {
            UserStore.setGuestData({
                email: email || '',
                first_name: first_name || '',
                last_name: last_name || '',
                company: company || '',
            });
        }

        const setup_token = query.get('setup_token');
        if (setup_token) {
            localStorage.setItem('setup_token', setup_token);
        }
    }, []);

    if (UserStore.isAuthenticated && !feedback_sales_order_name) {
        return <RedirectPreservingUTMQuery to={next_url} />;
    }

    return (
        <>
            <Card className="p-4 m-5 shadow-xl py-5 mx-auto">
                <AuthLayout
                    handleLogin={() => {
                        const searchParams = new URLSearchParams(location.search);
                        // Remove the 'next' parameter from the URL
                        searchParams.delete('next');
                        history.replace(`${next_url}?${searchParams.toString()}`);
                    }}
                />
            </Card>
        </>
    );
};

export default observer(PortalRegister);
